import { takeLatest, call, all } from "redux-saga/effects";
import { getReceiverWorker } from "services/Receiver/sagas";
import { getBranchesWorker } from "services/Branch/sagas";
import { getBrandsWorker } from "services/Brand/sagas";
import { initSchedulerModuleAction } from "modules/Scheduler/services/initialization/actions";

function* initSchedulerModuleWorker (){
    yield all([
        call(getBranchesWorker),
        call(getBrandsWorker),
        call(getReceiverWorker),
    ]);
}

export function* initScheduler() {
    yield all([
        yield takeLatest(initSchedulerModuleAction, initSchedulerModuleWorker)
    ]);
}
